import client from "../../../../../shared/api/client";

// Build the performers payload from a picker selection — link an existing artist
// or create one inline — and POST it. Uses the shared client, which injects the
// CSRF token from the meta tag (no per-call header mutation). Returns the promise.
export const addPerformer = ({ teamId, confirmId, actType = "headline", artistId, newArtistName, spotifyId, externalUrl }) => {
  const performer = { performable_id: confirmId, performable_type: "CalendarEvent", act_type: actType };
  if (artistId) {
    performer.artistable_type = "Artist";
    performer.artistable_id = artistId;
  } else {
    performer.artist_attributes = { name: newArtistName };
    if (spotifyId) performer.artist_attributes.spotify_id = spotifyId;
    if (externalUrl) performer.artist_attributes.external_url = externalUrl;
  }
  return client.post(`/teams/${teamId}/performers`, { performer });
};

// Swap the artist on an existing performer: link a different roster artist or
// create one inline. Performer#artist_attributes= reassigns artistable to a
// matched/new Artist (it never renames the currently-linked one).
export const updatePerformer = ({ teamId, performerId, artistId, newArtistName, spotifyId, externalUrl }) => {
  let performer;
  if (artistId) {
    performer = { artistable_type: "Artist", artistable_id: artistId };
  } else {
    performer = { artistable_type: "Artist", artist_attributes: { name: newArtistName } };
    if (spotifyId) performer.artist_attributes.spotify_id = spotifyId;
    if (externalUrl) performer.artist_attributes.external_url = externalUrl;
  }
  return client.patch(`/teams/${teamId}/performers/${performerId}`, { performer });
};

export const removePerformer = ({ teamId, performerId }) =>
  client.delete(`/teams/${teamId}/performers/${performerId}`);
